<div class="mat-dialog-ngx-image-cropper">
  <div class="detail-card-header flex--r-c mat-dialog-ngx-image-header">
    <span class="w-h-header-span">
      <div class="m-l--8 single-header">
        {{ "app.picturecrop.label" | translate }}
      </div>
    </span>
  </div>
  <div>
    <span whFlex="20" style="text-align: center">
      <img
        alt="croppedImage"
        class="picture mat-elevation-z4"
        [src]="croppedImage"
      />
    </span>
    <span whFlex>
      <div class="cropper-container" fxLayout="column" whFlex>
        <div class="image-cropper-wrapper">
          <image-cropper
            [imageChangedEvent]="data.imageChangedEvent"
            [maintainAspectRatio]="true"
            [aspectRatio]="1"
            [resizeToWidth]="270"
            format="png"
            (imageCropped)="imageCropped($event)"
            (imageLoaded)="imageLoaded()"
            output="base64"
            (cropperReady)="cropperReady()"
            (loadImageFailed)="loadImageFailed()"
          >
          </image-cropper>
        </div>
      </div>
    </span>
  </div>
  <w-h-button-group align="end" mat-dialog-actions>
    <w-h-button
      [text]="'app.cancel.label' | translate | uppercase"
      matIcon="close"
      (clicked)="cancel()"
    />
    <w-h-button
      [text]="'app.save.label' | translate | uppercase"
      matIcon="save"
      color="accent"
      type="flat"
      dataCy="image-crop-submit"
      [mat-dialog-close]="croppedImage"
    />
  </w-h-button-group>
</div>
